import React from 'react';
import { Row, Col, Layout, Tabs, Typography } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import 'antd/dist/reset.css';

import RealmObject from './RealmObject';
import RealmObjectsDisplay from './RealmObjectsDisplay';
import CampaignManager from './CampaignManager';
import CampaignDetails from './CampaignDetails';
import { useRealmContext } from '../contexts/RealmProvider';

import './css/CenterPanel.css';

const { Content } = Layout;
const { Title } = Typography;

const CenterPanel = () => {
  const { realmID } = useRealmContext();   // current realm name / ID

  /* --------- Build tab definitions --------- */
  const tabItems = [
    {
      key: '1',
      label: <Title level={2} className="custom-title">{realmID}</Title>,
      children: (
        <Row id="CenterPanel" className="element-margined-small">
          <Col xs={24} sm={24} md={12} lg={9}  xl={7}>
            <RealmObjectsDisplay />
          </Col>
          <Col xs={24} sm={24} md={12} lg={15} xl={17}>
            <RealmObject />
          </Col>
        </Row>
      ),
    },
    {
      key: '2',
      label: (
        <Title level={3} className="custom-title">
          <RightOutlined /> Campaigns
        </Title>
      ),
      children: (
        <Row id="CampaignPanel" className="element-margined-small">
          <Col xs={24} sm={24} md={12} lg={9}  xl={7}>
            <CampaignManager />
          </Col>
          <Col xs={24} sm={24} md={12} lg={15} xl={17}>
            <CampaignDetails />
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <Content className="panel-background-medium">
      <Tabs
        id="CenterPanelTabs"
        defaultActiveKey="1"
        className="center-panel"
        items={tabItems}
      />
    </Content>
  );
};

export default CenterPanel;
